let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8gTGU")).then(() => parcelRequire('g8Fnr'));